import axiosInstant from "../axiosInstant";

export async function login(ArrayData) {
  try {
    const response = await axiosInstant.post(
      `Login/`,
      ArrayData
    );

    console.log(
      "login console:",
      response.data.sucess
    );

    return response.data;
  } catch (error) {
    return error?.response?.data || {
      sucess: false,
      msg: "Unexpected error occurred.",
    };
  }
}

export async function forgetpassword(ArrayData) {
  try {
    const response = await axiosInstant.post(
      `user/reset-password`,
      ArrayData
    );

    const result = response.data;

    console.log(
      "Reset password response:",
      result
    );

    return result;
  } catch (error) {
    console.error(
      "Reset password error:",
      error?.response?.data || error.message
    );

    return {
      success: false,
      error:
        error?.response?.data ||
        "An unexpected error occurred.",
    };
  }
}

export async function verifyTokenEmail(token) {
  try {
    const response = await axiosInstant.get(
      `user/register/token-valid?token=${token}`
    );

    const result = response.data;

    console.log(
      "email verify response:",
      result
    );

    return result;
  } catch (error) {
    console.error(
      "email verify error:",
      error?.response?.data || error.message
    );

    return {
      success: false,
      error:
        error?.response?.data ||
        "An unexpected error occurred.",
    };
  }
}

export async function verifyToken(token) {
  try {
    const response = await axiosInstant.get(
      `user/token-valid?token=${token}`
    );

    const result = response.data;

    console.log(
      "Token validation response:",
      result
    );

    return result;
  } catch (error) {
    console.error(
      "Token validation error:",
      error?.response?.data || error.message
    );

    return {
      success: false,
      error:
        error?.response?.data ||
        "An unexpected error occurred.",
    };
  }
}

export async function resetPassword(ArrayData) {
  try {
    const response = await axiosInstant.post(
      `user/update-password`,
      ArrayData
    );

    const result = response.data;

    console.log(
      "Reset password response:",
      result
    );

    return result;
  } catch (error) {
    console.error(
      "Reset password error:",
      error?.response?.data || error.message
    );

    return {
      success: false,
      error:
        error?.response?.data ||
        "An unexpected error occurred.",
    };
  }
}

export async function auctionsLive() {
  try {
    const response = await axiosInstant.get(
      `live/current`
    );

    return response.data;
  } catch (error) {
    return (
      error?.response?.data || {
        sucess: false,
        msg: "Unexpected error occurred.",
      }
    );
  }
}